import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PullProductCreateModel } from "./pull-products.create.model";

export class PullProductFormModel extends FormGroup {
    constructor() {
        super({
            materialTypeId: new FormControl('', [Validators.required]),
            invoiceDate: new FormControl('', [Validators.required]),
        })
    }

    getPullProductData(): PullProductCreateModel {
        let repairWorkData = new PullProductCreateModel();
        repairWorkData.materialTypeId = this.get('materialTypeId').value;
        repairWorkData.invoiceDate = this.get('invoiceDate').value;
        return repairWorkData;

    }
}

